import { Component, OnInit, ViewChild, OnChanges, AfterViewInit } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { serviceUrl } from '../common/serviceconstants';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { GenericHttpClient } from '../Services/Basicauthentication';
import { UtilityServices } from './../UtilityServices';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';


@Component({
  selector: 'app-user-maintenance',
  templateUrl: './user-maintenance.component.html',
  styleUrls: ['./user-maintenance.component.scss']
})
export class UserMaintenanceComponent implements OnInit {
  staffFirstname: any = '';
  staffLastname: any = '';
  staffEmail: any = '';
  isstaffActive: any = false;
  isstaffGroup: any;
  dmessage: any;
  private paginator: MatPaginator;
  private sort: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private router: Router, private httpClient: GenericHttpClient,
    private utility: UtilityServices) {
    const userid = sessionStorage.getItem('UserID');
    if (userid === '' || userid == null || userid === undefined) {
      this.router.navigateByUrl('');
    } else {
      this.GetAllMaintenanceUsersList();
    }


  }

  UsersdataSource = new MatTableDataSource<any>();

  displayedColumns: string[] =
    [
      'LastName', 'Username', 'RoleName', 'Active', 'Update', 'Delete'
    ];

  ngOnInit(): void {
    this.FilterSource();
  }

  formControl: AbstractControl;
  FilterSource() {
    this.UsersdataSource.filterPredicate = ((data, filter) => {

      const a = !filter.LastName || data.LastName.toLowerCase().includes(filter.LastName.toLowerCase());
      const b = !filter.Username || data.Username.toLowerCase().includes(filter.Username.toLowerCase());
      const c = !filter.RoleName || data.RoleName.toLowerCase().includes(filter.RoleName.toLowerCase());
      const d = !filter.Active || data.Active.toLowerCase().includes(filter.Active.toLowerCase());
      return a && b && c && d;

    }) as (PeriodicElement, string) => boolean;

    this.formControl = this.formBuilder.group({
      LastName: '',
      Username: '',
      RoleName: '',
      Active: ''
    })
    this.formControl.valueChanges.subscribe(value => {
      const filter = { ...value } as string;
      this.UsersdataSource.filter = filter;
    });

  }

  setDataSourceAttributes(): void {
    this.UsersdataSource.paginator = this.paginator;
    this.UsersdataSource.sort = this.sort;
  }

  getDisplayedColumns(): string[] {
    return this.displayedColumns;
  }

  GetAllMaintenanceUsersList(): void {
    this.httpClient.get(serviceUrl + '/User/GetAllActiveUsersList',
      '').toPromise<any>().then(response => {
        this.UsersdataSource.data = response;
      });
  }

  issameuser; any = false;
  Deletestaffuser(EmailId: string): void {
    if (confirm('Do you want to delete selected Staff Member?')) {
      const userid = sessionStorage.getItem('UserID');
      if (userid === EmailId) {
        this.issameuser = true;
      }
      this.http.post(
        serviceUrl + "/User/DeleteUser",
        {
          EmailId: EmailId,

        }

      )
        .subscribe(res => {
          if (this.issameuser) {
            this.router.navigateByUrl('');
          } else {
            this.GetAllMaintenanceUsersList();
          }
        });
    }
  }

  UpdateStaffUser(item) {
    sessionStorage.setItem("updateuser", JSON.stringify(item));
    this.router.navigateByUrl('/StaffMaintenance');
  }

  AddNewStaff() {
    this.router.navigateByUrl('/StaffMaintenance');
  }




  GoBacktoDashboard() {
    this.router.navigateByUrl('/dashboard');
  }

}
